<section class="sh-dialog__content">
    @if (data.canRemove) {
        <p>{{ "exports.sidepanel.analog-dialog.message" | translate: { amount: data.amount } }}</p>
        <p class="analog-export-dialog__question">{{ "exports.sidepanel.analog-dialog.question" | translate }}</p>
        <ul class="sh-form-check-list analog-export-dialog__choices">
            <li class="sh-form-check sh-form-check-list__item analog-export-dialog__choice">
                <input
                    type="radio"
                    id="analog-export-choice-files-and-metadata"
                    name="analog-export-choice"
                    class="sh-radio sh-form-check__input"
                    [checked]="choice() === 'filesAndMetadata'"
                    (change)="select('filesAndMetadata')"
                />
                <label class="sh-form-check__label" for="analog-export-choice-files-and-metadata">
                    <span class="analog-export-dialog__label">{{ "exports.sidepanel.analog-dialog.files-and-metadata" | translate }}</span>
                    <span class="analog-export-dialog__hint">{{ "exports.sidepanel.analog-dialog.files-and-metadata-hint" | translate }}</span>
                </label>
            </li>
            <li class="sh-form-check sh-form-check-list__item analog-export-dialog__choice">
                <input
                    type="radio"
                    id="analog-export-choice-remove"
                    name="analog-export-choice"
                    class="sh-radio sh-form-check__input"
                    [checked]="choice() === 'remove'"
                    (change)="select('remove')"
                />
                <label class="sh-form-check__label" for="analog-export-choice-remove">
                    <span class="analog-export-dialog__label">{{ "exports.sidepanel.analog-dialog.remove" | translate }}</span>
                    <span class="analog-export-dialog__hint">{{ "exports.sidepanel.analog-dialog.remove-hint" | translate }}</span>
                </label>
            </li>
        </ul>
    } @else {
        <p>{{ "exports.sidepanel.analog-dialog.message-all" | translate }}</p>
    }
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" (click)="proceed()">
            @if (data.canRemove) {
                {{ "exports.sidepanel.analog-dialog.proceed" | translate }}
            } @else {
                {{ "exports.sidepanel.analog-dialog.files-and-metadata" | translate }}
            }
        </button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">
            {{ "exports.sidepanel.analog-dialog.cancel" | translate }}
        </button>
    </div>
</footer>
